/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setProfilePhotoApp} from '../api'

export const useMutationSetProfilePhotoApp = createReactQueryMutationHook('setProfilePhotoApp', setProfilePhotoApp)
